import { Box, IconButton } from '@chakra-ui/react'
import { ImageCommonComponent } from '@components/Common/Image'
import { ArrowLeftIcon, ArrowRightIcon } from '@src/icons'
import { StrapiBannerCarousel } from '@src/types/strapi'
import { carouselDelayInMs } from '@src/utils/delay'
import { useRef } from 'react'
import type { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './BannerCarousel.module.scss'

export const BannerCarousel = (props: StrapiBannerCarousel) => {
  const swiperRef = useRef<SwiperType | null>(null)
  const hasMoreThanOneItem = props.items.length > 1

  return (
    <Box
      height={{ base: '200px', md: '300px', lg: '300px', xl: '420px', '2xl': '560px' }}
      position="relative"
    >
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        slidesPerView={1}
        slidesPerGroup={1}
        className={styles.customCarousel}
        onBeforeInit={swiper => {
          swiperRef.current = swiper
        }}
        autoplay={{
          enabled: hasMoreThanOneItem,
          delay: carouselDelayInMs(props.timeout),
        }}
        pagination={{
          clickable: true,
          enabled: true,
          bulletClass: `swiper-pagination-bullet ${styles.customBullet}`,
          bulletActiveClass: `swiper-pagination-bullet-active ${styles.customBulletActive}`,
        }}
      >
        {props.items.map(item => (
          <SwiperSlide key={item.id} className={styles.customCarouselItem}>
            {item.link ? (
              <a href={item.link} target={item.isExternal ? '_blank' : '_self'}>
                <ImageCommonComponent {...item} />
              </a>
            ) : (
              <ImageCommonComponent {...item} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      {hasMoreThanOneItem && (
        <>
          <IconButton
            icon={<ArrowLeftIcon />}
            variant="unstyled"
            display={{ base: 'none', md: 'flex' }}
            aria-label="prev-button"
            position="absolute"
            top="50%"
            transform="translateY(-50%)"
            left={{ md: '4', lg: '8' }}
            backgroundColor="white"
            borderRadius="full"
            zIndex={2}
            width="48px"
            height="48px"
            onClick={() => swiperRef.current?.slidePrev()}
            _hover={{ opacity: 0.8 }}
          />
          <IconButton
            icon={<ArrowRightIcon />}
            display={{ base: 'none', md: 'flex' }}
            variant="unstyled"
            aria-label="next-button"
            backgroundColor="white"
            position="absolute"
            top="50%"
            transform="translateY(-50%)"
            right={{ md: '4', lg: '8' }}
            zIndex={2}
            borderRadius="full"
            width="48px"
            height="48px"
            onClick={() => swiperRef.current?.slideNext()}
            _hover={{ opacity: 0.8 }}
          />
        </>
      )}
    </Box>
  )
}
